import React, { useMemo } from 'react'
import ModulePanel from '../../../ui/ModulePanel/ModulePanel'
import Button from '../../../ui/Button/Button'
import Field from '../../../ui/Field/Field'
import StatusMessage, { initStatusMessage, useStatusMessage } from '../../../ui/StatusMessage/StatusMessage'
import PackagingCategoryPicker from './PackagingCategoryPicker'
import { buildPackagingTierSelectOptions } from '../../../api/marketing/gifts/giftWithPurchaseConfigHelpers'
import { useGiftsConfig } from './GiftsConfigContext'
import styles from './GiftsPackaging.module.scss'

function GiftsPackaging() {
  const {
    draft,
    sortedTiers,
    isDirty,
    isSaving,
    resetToBaseline,
    saveConfig,
    setPackagingCategory,
    setFreeFromTierId,
  } = useGiftsConfig()
  const [statusMessage, setStatusMessage] = useStatusMessage()

  const tierOptions = useMemo(() => buildPackagingTierSelectOptions(sortedTiers), [sortedTiers])
  const freeFromTierId = draft.packaging?.freeFromTierId || ''

  const onCancelChanges = () => {
    resetToBaseline()
    setStatusMessage(initStatusMessage())
  }

  const onSave = async () => {
    const result = await saveConfig()

    if (!result.ok) {
      setStatusMessage({
        show: true,
        type: 'fail',
        message: result.message || 'Не вдалося зберегти',
        closeAfter: 6000,
      })
      return
    }

    setStatusMessage({
      show: true,
      type: 'success',
      message: 'Дані збережено',
      closeAfter: 4000,
    })
  }

  return (
    <div className={styles.root}>
      {statusMessage.show ? (
        <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
      ) : null}

      <ModulePanel title="Подарункове пакування">
        <div className={styles.fields}>
          <div className={styles.field}>
            <PackagingCategoryPicker
              label="Категорія пакування"
              value={draft.packaging?.categorySelection || null}
              onChange={setPackagingCategory}
            />
          </div>

          <div className={styles.field}>
            <Field
              fieldType="select"
              config={{
                label: 'Безкоштовно від',
                getOptions: tierOptions,
              }}
              value={freeFromTierId}
              changed={(event) => setFreeFromTierId(event.target.value || null)}
              isChangable
            />
          </div>
        </div>
      </ModulePanel>

      <div className={styles.footer}>
        <Button
          title="Зберегти"
          theme="solid"
          fill="accent"
          size={32}
          isLoading={isSaving}
          onClick={onSave}
        />
        {isDirty && !isSaving ? (
          <Button title="Скасувати зміни" theme="bounded" size={32} onClick={onCancelChanges} />
        ) : (
          <button
            type="button"
            className={['Button', 'Button_theme_bounded', 'Button_size_32', styles.saveDisabled].join(' ')}
            disabled
          >
            <span className="Button-Content">Скасувати зміни</span>
          </button>
        )}
      </div>
    </div>
  )
}

export default GiftsPackaging
